
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'ButtonLoading'
})
export default class ButtonLoading extends Vue {
  @Prop({ type: Function, required: true }) readonly handleFn!: () => Promise<
    any
  >
  @Prop({ type: Boolean, default: () => false }) readonly disabled!: boolean

  isLoading = false
  result = null
  error = null

  async run() {
    const now = Date.now()
    try {
      if (!this.disabled) {
        this.error = null
        this.isLoading = true
        this.result = await this.handleFn()
      }
    } catch (e) {
      this.error = e
    } finally {
      this.isLoading = false
      this.$emit('done', {
        ...this.$data,
        cost: Date.now() - now
      })
    }
  }
}
